module.exports = __webpack_public_path__ + "static/media/revenueStreams.e8dbff10.svg";